import { homeFaqs } from '@/mocks/faqs';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-100 py-12 md:py-16">
      <div className="container-page grid grid-cols-1 gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-question-line" aria-hidden="true" />
            </span>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[28px]">
            关于排期、回放和提醒的疑问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            这里整理了观众最常问的几个问题，涉及排期更新频率、提醒设置方式、回放保留时长和热门推荐的计算规则。
            如果还有没覆盖到的，欢迎通过页脚邮箱联系，我们会补充到这一栏。
          </p>
          <ul className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
            {['每 15 分钟校对一次排期', '重点场次提前 30 分钟提醒', '回放按分类与时长筛选'].map((text) => (
              <li key={text} className="flex items-start gap-2">
                <span className="mt-0.5 w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-check-line" aria-hidden="true" />
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        <FaqAccordion items={homeFaqs} />
      </div>
    </section>
  );
}